import { FC } from "react";

import { ChooseInfoBlockItemModal as Component } from "shared/components";
import { ChooseInfoBlockItemBaseProps, useChooseInfoBlockItem } from "shared/utils";
import { IAPIState } from "shared/types";
import { useGetInfoBlockItems } from "Bands/utils";

export const ChooseInfoBlockItemModal: FC<ChooseInfoBlockItemBaseProps> = ({
  type,
  handleClose,
  handleAddNew,
  infoBlockApiStatus,
  ...rest
}) => {
  const { apiMeta, items, pagination, fetchItems } = useGetInfoBlockItems(type);

  const { fetchedOnce, openCreateModal, itemReadbleName } = useChooseInfoBlockItem({
    type,
    items,
    handleClose,
    handleAddNew,
    getItemsApiStatus: apiMeta?.status,
    infoBlockApiStatus,
  });

  if (apiMeta?.status === IAPIState.pending && !fetchedOnce.current) return null;

  return (
    <Component
      type={type}
      items={items}
      getItemsApiStatus={apiMeta?.status}
      pagination={pagination}
      fetchItems={fetchItems}
      openCreateModal={openCreateModal}
      itemReadbleName={itemReadbleName}
      handleClose={handleClose}
      {...rest}
    />
  );
};
